import { render, staticRenderFns } from "./ShopCardHeaderButton.vue?vue&type=template&id=6c7d8618&scoped=true&"
import script from "./ShopCardHeaderButton.vue?vue&type=script&lang=js&"
export * from "./ShopCardHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7d8618",
  null
  
)

export default component.exports